import { z } from 'zod'

export const GetStationNamesQuerySchema = z.object({
    __typename: z.literal('query_root').optional(),
    station: z.array(
        z.object({
            __typename: z.literal('station').optional(),
            station_name: z.string(),
            device_uuid: z.string().nullish(),
            lot_section_id: z.string().nullish()
        })
    )
})

export type GetStationNamesQuery = z.infer<typeof GetStationNamesQuerySchema>

export const UpdateStationConfigQuerySchema = z.object({
    __typename: z.literal('query_root').optional(),
    update_station_config: z
        .object({
            __typename: z.literal('UpdateStationOutput').optional(),
            message: z.string()
        })
        .nullish()
})

export type UpdateStationConfigQuery = z.infer<typeof UpdateStationConfigQuerySchema>

export const GetStationDataByNameQuerySchema = z.object({
    __typename: z.literal('query_root').optional(),
    station: z.array(
        z.object({
            __typename: z.literal('station').optional(),
            station_name: z.string(),
            lot_section_id: z.string().nullish(),
            device_uuid: z.string().nullish(),
            config_timestamp: z.string().nullish(),
            // Upstream codegen types this as `any` (Scalars['json']); kept loose to match.
            config: z.any(),
            device_direction: z.string().nullish(),
            type: z.string(),
            enabled: z.boolean()
        })
    )
})

export type GetStationDataByNameQuery = z.infer<typeof GetStationDataByNameQuerySchema>

export const MutationRootUpdateStationDataMutationArgsSchema = z.object({
    device_direction: z.string().nullish(),
    device_uuid: z.string().nullish(),
    lot_section_id: z.string().nullish(),
    station_name: z.string()
})

export type MutationRootUpdateStationDataMutationArgs = z.infer<typeof MutationRootUpdateStationDataMutationArgsSchema>

const MessageOutputSchema = z
    .object({
        __typename: z.string().optional(),
        message: z.string()
    })
    .nullish()

export const UpdateStationDataQuerySchema = z.object({
    __typename: z.literal('query_root').optional(),
    update_station_data: MessageOutputSchema
})

export type UpdateStationDataQuery = z.infer<typeof UpdateStationDataQuerySchema>

export const DeleteStationMutationSchema = z.object({
    __typename: z.literal('mutation_root').optional(),
    delete_station: z
        .object({
            __typename: z.literal('station_mutation_response').optional(),
            affected_rows: z.number()
        })
        .nullish()
})

export type DeleteStationMutation = z.infer<typeof DeleteStationMutationSchema>

export const UpdateStationDataMutationSchema = z.object({
    message: z.string()
})

export type UpdateStationDataMutation = z.infer<typeof UpdateStationDataMutationSchema>

export const UpdateStationEnabledMutationVariablesSchema = z.object({
    station_name: z.string(),
    enabled: z.boolean()
})

export type UpdateStationEnabledMutationVariables = z.infer<typeof UpdateStationEnabledMutationVariablesSchema>

export const UpdateStationEnabledMutationSchema = z.object({
    message: z.string()
})

export type UpdateStationEnabledMutation = z.infer<typeof UpdateStationEnabledMutationSchema>

export const UpdateStationConfigMutationVariablesSchema = z.object({
    station_name: z.string(),
    // Upstream codegen types this as `Scalars['json']` (i.e. `any`); kept loose to match.
    config: z.any(),
    // Optimistic-concurrency token from the fetched config; null/absent when the station has
    // no config yet (first-time create), which the backend accepts.
    timestamp: z.string().nullish()
})

export type UpdateStationConfigMutationVariables = z.infer<typeof UpdateStationConfigMutationVariablesSchema>

export const UpdateStationConfigMutationSchema = z.object({
    message: z.string()
})

export type UpdateStationConfigMutation = z.infer<typeof UpdateStationConfigMutationSchema>

export const TriggerScsFetchOccupancyMutationVariablesSchema = z.object({
    force_update_lot: z.string()
})

export type TriggerScsFetchOccupancyMutationVariables = z.infer<typeof TriggerScsFetchOccupancyMutationVariablesSchema>

export const TriggerScsFetchOccupancyMutationSchema = z.object({
    message: z.string()
})

export type TriggerScsFetchOccupancyMutation = z.infer<typeof TriggerScsFetchOccupancyMutationSchema>

export const GetDeviceSystemImageVariablesSchema = z.object({
    device_uuid: z.string(),
    latest: z.boolean(),
    roi_image: z.boolean().optional()
})

export type GetDeviceSystemImageVariables = z.infer<typeof GetDeviceSystemImageVariablesSchema>

export const GetDeviceSystemImageQuerySchema = z.object({
    signed_url: z.string().nullish(),
    timestamp: z.string().nullish()
})

export type GetDeviceSystemImageQuery = z.infer<typeof GetDeviceSystemImageQuerySchema>

export const GetCoordinateParkingDetectionsQuerySchema = z.object({
    __typename: z.literal('query_root').optional(),
    parking_detections: z.array(
        z.object({
            __typename: z.literal('parking_detections').optional(),
            missing_lp: z.boolean().nullish(),
            // Upstream codegen types this as `Scalars['json']` (i.e. `any`); kept loose to match.
            coordinates: z.any(),
            device_uuid: z.string().nullish()
        })
    )
})

export type GetCoordinateParkingDetectionsQuery = z.infer<typeof GetCoordinateParkingDetectionsQuerySchema>
